var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89453 4.62964L2.89453 4.52154C2.89453 3.41697 3.78996 2.52154 4.89453 2.52154L10.6601 2.52154C11.0802 2.52154 11.4208 2.18093 11.4208 1.76077V1.76077C11.4208 1.34061 11.7615 1 12.1816 1L16.9998 1C18.1044 1 18.9998 1.89543 18.9998 3L18.9998 13C18.9998 14.1046 18.1044 15 16.9998 15L10.9472 15",
    stroke: "#2A2D34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57941 15L16.5969 15C17.8469 15 18.7906 13.8661 18.5636 12.6368L17.3873 6.26648C17.2122 5.318 16.3851 4.62964 15.4206 4.62964L3.40311 4.62964C2.15308 4.62964 1.20938 5.76355 1.43636 6.9928L2.61266 13.3632C2.78779 14.3116 3.6149 15 4.57941 15Z",
    stroke: "#2A2D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDark);
export default __webpack_public_path__ + "static/media/folder_dark.4f3c2ea7fd588a2ba46541948158cabd.svg";
export { ForwardRef as ReactComponent };